






















































































import { Component, Vue } from "vue-property-decorator";
import OpenApiDocs from "@/components/OpenApiDocs.vue";
import * as uiUtil from "@/uiUtil";

@Component({
  components: { OpenApiDocs }
})
export default class ClientAPI extends Vue {
  apiLoadError = false;
  apiLoading = true;
  apiEnabledLoading = false;
  apiKeyLoading = false;
  userConfig = {
    publicApiEnabled: false,
    publicApiKey: ""
  };

  get lang() {
    return this.$store.state.lang.data;
  }

  get isIE11() {
    return uiUtil.isIE11();
  }
}
